var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 57,
    viewBox: "0 0 178 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.801 0.683472C149.839 2.27221 153.102 3.1174 156.108 4.62421C159.877 6.51266 161.856 9.17888 158.892 16.1312C160.088 11.0144 157.146 6.42866 151.481 7.48021C153.786 13.5417 156.092 19.6042 158.396 25.6657C161.59 35.3983 147.545 39.1368 145.131 32.3152C143.239 27.0346 150.712 22.4395 155.722 24.1661L155.729 24.1599L146.801 0.683472ZM164.203 5.4331L164.021 41.3322L164.007 41.3353C158.228 36.4291 145.917 38.6546 145.723 46.6688C145.43 57.006 166.047 59.3424 166.798 44.7264C166.846 35.4564 166.892 26.1863 166.94 16.9162C175.02 18.4676 176.579 26.1033 172.359 32.2913C179.877 24.582 178.613 20.0014 174.567 15.5245C171.339 11.953 167.429 9.13014 164.203 5.4331Z",
    fill: "#2F2A27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4152 57L9.17341 29.529V57H0V3H9.99512L18.8266 30.9461V3H28V57H18.4152Z",
    fill: "#2F2A27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1214 12.7996C47.1214 11.8606 46.1635 11.1895 44.9995 11.1895C43.8376 11.1895 42.8797 11.8606 42.8797 12.7996V46.2014C42.8797 47.1405 43.8376 47.8115 44.9995 47.8115C46.1635 47.8115 47.1214 47.1405 47.1214 46.2014V12.7996ZM44.9995 57C37.7474 57 32 51.2317 32 45.8004V13.2027C32 7.76832 37.7474 2 44.9995 2C52.2526 2 58 7.76832 58 13.2027V45.8004C58 51.2317 52.2526 57 44.9995 57Z",
    fill: "#2F2A27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0287 12.2479V57H67.305V12.2479H60V3H85V12.2479H78.0287Z",
    fill: "#2F2A27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 57V3H110V11.9108H99.666V24.195H106.467V33.7801H99.666V47.4149H110V57H89Z",
    fill: "#2F2A27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.098 14.7461C129.098 13.1931 128.422 12.5852 127.271 12.5852H124.833V47.4832H127.271C128.422 47.4832 129.098 46.8764 129.098 45.3234V14.7461ZM128.15 57H114V3H128.15C133.364 3 140 5.97101 140 12.855V47.145C140 54.0311 133.364 57 128.15 57Z",
    fill: "#2F2A27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoted);
export default __webpack_public_path__ + "static/media/noted.ce4a7de5.svg";
export { ForwardRef as ReactComponent };